import buttonStyle from "./customButtons.module.css";

import { useState } from "react";
import Button, { TextColorType } from "./Button";

function ButtonShowcase() {
  const [text, setText] = useState<TextColorType>("light");

  function getOpposite(text: TextColorType) {
    if (text === "light") return "dark";
    else return "light";
  }

  return (
    <div className={buttonStyle.showcaseWrapper}>
      <Button variant="primary" color="blue" textcolor={getOpposite(text)} onClick={() => {setText(getOpposite(text))}}>
        Change Text
      </Button>
      <br />
      <br />

      <Button variant="primary" color="blue" textcolor={text}>
        Button
      </Button>
      <Button variant="secondary" color="blue" textcolor={text}>
        Button
      </Button>
      <Button variant="tertiary" color="blue" textcolor={text}>
        Button
      </Button>
      <br />

      <Button variant="primary" color="green" textcolor={text}>
        Button
      </Button>
      <Button variant="secondary" color="green" textcolor={text}>
        Button
      </Button>
      <Button variant="tertiary" color="green" textcolor={text}>
        Button
      </Button>
      <br />

      <Button variant="primary" color="red" textcolor={text}>
        Button
      </Button>
      <Button variant="secondary" color="red" textcolor={text}>
        Button
      </Button>
      <Button variant="tertiary" color="red" textcolor={text}>
        Button
      </Button>
    </div>
  );
}
export default ButtonShowcase;
